// Klient til Klimadatastyrelsens Adressevælger, som erstatter DAWA.
// Dokumentation: https://confluence.kds.dk/pages/viewpage.action?pageId=244318431
const API_URL = "https://adressevaelger.dk";

class AdresseVaelgerService {
    // searchType er "adresser" eller "husnumre". Returnerer listen af fund,
    // som kan være af typen vejnavn, navngivenvejpostnummer, husnummer eller adresse.
    async search(tekst, {searchType = "adresser", signal} = {}) {
        const params = new URLSearchParams({
            tekst,
            token: process.env.REACT_APP_ADRESSEVAELGER_TOKEN,
        });
        const response = await fetch(`${API_URL}/${searchType}/soeg?${params}`, {signal});
        if (!response.ok) {
            throw new Error(`Adressevælger svarede med status ${response.status}`);
        }
        const data = await response.json();
        if (data.status === "fejl") {
            throw new Error(`Adressevælger fejl: ${data.beskrivelse}`);
        }
        return data.fund;
    }

    // Finder den fulde adressebetegnelse (fx "Ahorn Alle 1, 3220 Tisvildeleje") ud fra en delvis adresse.
    async findAddressText(tekst) {
        const fund = await this.search(tekst);
        const match = fund.find((item) => item.type === "adresse" || item.type === "husnummer");
        return match?.titel;
    }
}

export default new AdresseVaelgerService();
